var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { sdsCustomElement } from '../utilities/custom-components';
import styles from './sds-link.lit.scss';
import { property } from 'lit/decorators.js';
/**
 * Control that represents a Link component.
 *
 * @slot - This slot is the container for the link content (text, icons, etc.)
 * @slot icon - This slot is for icon content within the link
 *
 * @tag sds-link
 */
let SdsLink = (() => {
    var _SdsLink_href_accessor_storage, _SdsLink_target_accessor_storage, _SdsLink_disabled_accessor_storage, _SdsLink_button_accessor_storage, _SdsLink_routing_accessor_storage, _SdsLink_onlyIcon_accessor_storage, _SdsLink_download_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-link')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _href_decorators;
    let _href_initializers = [];
    let _href_extraInitializers = [];
    let _target_decorators;
    let _target_initializers = [];
    let _target_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _button_decorators;
    let _button_initializers = [];
    let _button_extraInitializers = [];
    let _routing_decorators;
    let _routing_initializers = [];
    let _routing_extraInitializers = [];
    let _onlyIcon_decorators;
    let _onlyIcon_initializers = [];
    let _onlyIcon_extraInitializers = [];
    let _download_decorators;
    let _download_initializers = [];
    let _download_extraInitializers = [];
    var SdsLink = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsLink_href_accessor_storage.set(this, __runInitializers(this, _href_initializers, void 0));
            _SdsLink_target_accessor_storage.set(this, (__runInitializers(this, _href_extraInitializers), __runInitializers(this, _target_initializers, void 0)));
            _SdsLink_disabled_accessor_storage.set(this, (__runInitializers(this, _target_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsLink_button_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _button_initializers, false)));
            _SdsLink_routing_accessor_storage.set(this, (__runInitializers(this, _button_extraInitializers), __runInitializers(this, _routing_initializers, false)));
            _SdsLink_onlyIcon_accessor_storage.set(this, (__runInitializers(this, _routing_extraInitializers), __runInitializers(this, _onlyIcon_initializers, false)));
            _SdsLink_download_accessor_storage.set(this, (__runInitializers(this, _onlyIcon_extraInitializers), __runInitializers(this, _download_initializers, false)));
            /**
             * Handles navigation events for custom and button links.
             * Dispatches a custom 'click' event with href in the detail.
             *
             * @param event - The mouse or keyboard event
             */
            this.handleNavigation = (__runInitializers(this, _download_extraInitializers), (event) => {
                if (this.disabled) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
                event.stopPropagation();
                event.preventDefault();
                const clickEvent = new CustomEvent('click', {
                    bubbles: false,
                    cancelable: true,
                    detail: {
                        href: this.href,
                    },
                });
                this.dispatchEvent(clickEvent);
            });
            /**
             * Handles keyboard events for link activation.
             * Supports Enter and Space keys for accessibility.
             *
             * @param event - The keyboard event
             */
            this.handleKeyDown = (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    this.handleNavigation(event);
                    return;
                }
            };
        }
        /**
         * Defines the hyperlink reference for the link item.
         * When set, the item becomes a clickable link.
         *
         * @attr {string} href - The URL the link item should point to.
         */
        get href() { return __classPrivateFieldGet(this, _SdsLink_href_accessor_storage, "f"); }
        set href(value) { __classPrivateFieldSet(this, _SdsLink_href_accessor_storage, value, "f"); }
        /**
         * Specifies where to open the linked document.
         *
         * Defaults to `_self`.
         *
         * @attr {string} target - Target window for the link.
         */
        get target() { return __classPrivateFieldGet(this, _SdsLink_target_accessor_storage, "f"); }
        set target(value) { __classPrivateFieldSet(this, _SdsLink_target_accessor_storage, value, "f"); }
        /**
         * Disables the link, making it non-interactive.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} disabled - Disables the link.
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsLink_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsLink_disabled_accessor_storage, value, "f"); }
        /**
         * Renders the link as a button element instead of an anchor.
         * Useful for actions that don't navigate to URLs.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} button - Renders as button element.
         */
        get button() { return __classPrivateFieldGet(this, _SdsLink_button_accessor_storage, "f"); }
        set button(value) { __classPrivateFieldSet(this, _SdsLink_button_accessor_storage, value, "f"); }
        /**
         * Enables custom navigation behavior instead of native browser navigation.
         * When true, clicking the link dispatches a custom 'click' event for application-level routing.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} routing - Enables custom navigation.
         */
        get routing() { return __classPrivateFieldGet(this, _SdsLink_routing_accessor_storage, "f"); }
        set routing(value) { __classPrivateFieldSet(this, _SdsLink_routing_accessor_storage, value, "f"); }
        /**
         * Indicates that the link contains only an icon without text.
         * Applies special styling for icon-only links.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} only-icon - Icon-only link styling.
         */
        get onlyIcon() { return __classPrivateFieldGet(this, _SdsLink_onlyIcon_accessor_storage, "f"); }
        set onlyIcon(value) { __classPrivateFieldSet(this, _SdsLink_onlyIcon_accessor_storage, value, "f"); }
        /**
         * Indicates that the link should be downloaded instead of navigated to.
         * Can be a string to specify the filename, or true for default filename.
         *
         * Defaults to `false`.
         *
         * @attr {string|boolean} download - Download attribute for the link.
         */
        get download() { return __classPrivateFieldGet(this, _SdsLink_download_accessor_storage, "f"); }
        set download(value) { __classPrivateFieldSet(this, _SdsLink_download_accessor_storage, value, "f"); }
        render() {
            return html `${this.renderLink()}`;
        }
        /**
         * Determines which type of link to render based on component properties.
         *
         * @returns The appropriate template for the link type
         */
        renderLink() {
            if (this.routing) {
                return this.renderLinkCustomNavigation();
            }
            if (this.button) {
                return this.renderButtonLink();
            }
            return this.renderLinkNativeNavigation();
        }
        /**
         * Renders a native anchor element with browser navigation.
         *
         * @returns Template for native navigation link
         */
        renderLinkNativeNavigation() {
            return html `
            <a
                part="sds-link"
                href="${this.disabled ? undefined : this.href}"
                target="${ifDefined(this.target)}"
                download="${ifDefined(this.download || undefined)}"
                class="${this.getClasses()}"
                ?disabled="${this.disabled}"
                tabindex="${this.disabled ? '-1' : '0'}"
            >
                <slot></slot>
            </a>
        `;
        }
        /**
         * Renders a custom navigation link that dispatches events.
         *
         * @returns Template for custom navigation link
         */
        renderLinkCustomNavigation() {
            return html `
            <span @click="${this.handleNavigation}">
                <a
                    href="${this.href}"
                    target="${ifDefined(this.target)}"
                    download="${ifDefined(this.download || undefined)}"
                    class="${this.getClasses()}"
                    part="sds-link"
                    ?disabled="${this.disabled}"
                    tabindex="${this.disabled ? '-1' : '0'}"
                    @keydown="${this.handleKeyDown}"
                >
                    <slot></slot>
                </a>
            </span>
        `;
        }
        /**
         * Renders the link as a button element.
         *
         * @returns Template for button-style link
         */
        renderButtonLink() {
            return html `
            <button
                @click="${this.handleNavigation}"
                class="${this.getClasses()}"
                part="sds-link"
                ?disabled="${this.disabled}"
                tabindex="${this.disabled ? '-1' : '0'}"
                @keydown="${this.handleKeyDown}"
            >
                <slot></slot>
            </button>
        `;
        }
        /**
         * Programmatically triggers a click on the link element.
         * Works for both anchor and button elements.
         */
        click() {
            var _a;
            const linkElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('a, button');
            if (linkElement && !this.disabled) {
                linkElement.click();
            }
        }
        getClasses() {
            return classMap({
                'sds-link': true,
                'sds-link--disabled': this.disabled,
                'sds-link--only-icon': this.onlyIcon,
            });
        }
    };
    _SdsLink_href_accessor_storage = new WeakMap();
    _SdsLink_target_accessor_storage = new WeakMap();
    _SdsLink_disabled_accessor_storage = new WeakMap();
    _SdsLink_button_accessor_storage = new WeakMap();
    _SdsLink_routing_accessor_storage = new WeakMap();
    _SdsLink_onlyIcon_accessor_storage = new WeakMap();
    _SdsLink_download_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsLink");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _href_decorators = [property({ type: String })];
        _target_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _button_decorators = [property({ type: Boolean })];
        _routing_decorators = [property({ type: Boolean })];
        _onlyIcon_decorators = [property({ type: Boolean, attribute: 'only-icon' })];
        _download_decorators = [property({ type: String })];
        __esDecorate(_classThis, null, _href_decorators, { kind: "accessor", name: "href", static: false, private: false, access: { has: obj => "href" in obj, get: obj => obj.href, set: (obj, value) => { obj.href = value; } }, metadata: _metadata }, _href_initializers, _href_extraInitializers);
        __esDecorate(_classThis, null, _target_decorators, { kind: "accessor", name: "target", static: false, private: false, access: { has: obj => "target" in obj, get: obj => obj.target, set: (obj, value) => { obj.target = value; } }, metadata: _metadata }, _target_initializers, _target_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _button_decorators, { kind: "accessor", name: "button", static: false, private: false, access: { has: obj => "button" in obj, get: obj => obj.button, set: (obj, value) => { obj.button = value; } }, metadata: _metadata }, _button_initializers, _button_extraInitializers);
        __esDecorate(_classThis, null, _routing_decorators, { kind: "accessor", name: "routing", static: false, private: false, access: { has: obj => "routing" in obj, get: obj => obj.routing, set: (obj, value) => { obj.routing = value; } }, metadata: _metadata }, _routing_initializers, _routing_extraInitializers);
        __esDecorate(_classThis, null, _onlyIcon_decorators, { kind: "accessor", name: "onlyIcon", static: false, private: false, access: { has: obj => "onlyIcon" in obj, get: obj => obj.onlyIcon, set: (obj, value) => { obj.onlyIcon = value; } }, metadata: _metadata }, _onlyIcon_initializers, _onlyIcon_extraInitializers);
        __esDecorate(_classThis, null, _download_decorators, { kind: "accessor", name: "download", static: false, private: false, access: { has: obj => "download" in obj, get: obj => obj.download, set: (obj, value) => { obj.download = value; } }, metadata: _metadata }, _download_initializers, _download_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsLink = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsLink = _classThis;
})();
export { SdsLink };
